<template>
    <a
        class="map-course-post"
        :class="{
            'map-no-image': noImage,
            'map-featured': featured,
        }"
        @click.prevent="read_more"
    >
        <div class="map-article-info">
            <h2>{{ title }}</h2>
            <template v-if="!noImage">
                <lazy-img :src="get_image()" v-if="showImage" />
                <div v-else class="map-article-image-placeholder"></div>
            </template>
            <p>{{ excerpt }}</p>
            <span class="map-course-points" v-if="points">{{ points }}</span>
            <span class="map-course-state" :class="{'map-progress-done': progress === 'done'}">{{ progress || 'In progress' }}</span>
        </div>
    </a>
</template>

<script>
    import LazyImg from '@/components/LazyImg';

    export default
    {
        name: 'course-post',
        components:
        {
            LazyImg,
        },
        props:
        {
            featured: Boolean,
            noImage: Boolean,
            image: [String, Object],
            points: Number,
            title: String,
            excerpt: String,
            link: String,
            progress: String,
        },
        data()
        {
            return {
                showImage: true,
            };
        },
        watch: {
            image()
            {
                this.showImage = null;
                setTimeout(() => this.showImage = this.image);
            },
        },
        mounted()
        {
            this.showImage = !!this.image;
        },
        methods:
        {
            read_more()
            {
                this.$router.push(this.link);
            },
            get_image()
            {
                if (this.image && this.image.id)
                {
                    return process.env.VUE_APP_BACKEND_URL + 'api/files/' + this.image.id + '/400x400_crop';
                }
                else if (this.image)
                {
                    return this.image;
                }

                this.showImage = false;
            },
        },
    }
</script>
